module.exports = __webpack_public_path__ + "img/ic-pt-earrings.9a68c5f3.svg";